import axios from "axios";
import Config from "../utils/Config";

class OrganizerService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getOrganizers() {
    try {
      const response = await axios.get(
        `${Config.API_BASE_URL}/admin/organizers`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Organizers fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.reason ||
          "An error occurred while getting organizers",
      };
    }
  }

  async createOrganizer(payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/create/organizer`,
        payload,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message:
          response.data?.data?.reason || "Organizer created successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while creating organizer",
      };
    }
  }

  async updateOrganizer(organizer_slug, payload) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/update/organizers/${organizer_slug}`,
        { ...payload, slug:organizer_slug },
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message:
          response.data?.data?.reason || "Organizer updated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while updating organizer",
      };
    }
  }

  async deleteOrganizer(organizer_slug) {
    try {
      const response = await axios.post(
        `${Config.API_BASE_URL}/admin/delete/organizers/${organizer_slug}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data?.data,
        message:
          response.data?.data?.reason || "Organizer deleted successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason ||
          "An error occurred while deleting organizer",
      };
    }
  }
}

const organizerService = new OrganizerService();
export default organizerService;
